import styled from "styled-components";
import { Colors, TextColorNames } from "@smartsuite/types";

export const Container = styled.div`
  background-color: ${Colors.custom17};
  width: 100%;
  margin: 13px 0px 0px 15px;
  padding: 9px 15px;
  border-radius: 8px;

  display: flex;
  align-items: center;

  min-height: 36px;
`;

export const Text = styled.div`
  font-weight: 400;
  font-size: 13px;
  display: inline;
  min-width: 200px;

  color: ${Colors.custom15};
  line-height: 18px;
  padding: 0px 0px 0px 15px;
`;

export const Link = styled.div<{ color?: string }>`
  font-weight: 400;
  font-size: 13px;
  display: inline;
  color: ${({ color }) =>
    color === undefined ? TextColorNames.secondary : color};
  line-height: 18px;
  padding: 0px 0px 0px 4px;
  min-width: 115px;

  text-decoration: underline;
  cursor: pointer;
`;

export const MenuTitle = styled.div`
  font-weight: 600;
  font-size: 11px;
  display: inline;
  color: ${TextColorNames.secondary};
  line-height: 16px;
  padding-left: 15px;
`;

export const MenuText = styled.div`
  font-weight: 500;
  font-size: 13px;
  display: inline;
  color: ${TextColorNames.tertiary};
`;
